import { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Container as StyledContainer } from '../pages/Questionnaire/styles';


export default function PausedView({ payload, onResume }) {
  const forcePaused = !!payload?.forcePaused;
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update currentTime every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <StyledContainer style={{ zIndex: 500 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1
        }}
      >
        <Typography variant="h3" sx={{ mb: 4, color: "text.primary" }}>
          {forcePaused ? "המבחן הופסק על ידי המפעיל" : "מבחן בהפסקה"}
        </Typography>
        <Typography
          variant="h1"
          sx={{ fontSize: "2rem", fontWeight: "bold", color: "text.primary" }}
        >
          {currentTime.toLocaleTimeString()}
        </Typography>
        {!forcePaused && (
          <Button
            variant="contained"
            sx={{
              mt: 4,
              bgcolor: "primary.main",
              color: "primary.contrastText",
              "&:hover": { bgcolor: "primary.dark" }
            }}
            onClick={onResume}
          >
            חזרה למבחן
          </Button>
        )}
      </Box>
    </StyledContainer>
  );
}
